export default "__VITE_ASSET__DtLr9cUc__"